module.exports = ".img-container img {\n\tmax-height: 50px;\n\tborder-radius: 25px;\n}\n\ntbody tr {\n\tcursor: pointer;\n}\n\n.disabled {\n\tpointer-events: none;\n\tcursor: not-allowed;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/home/home.component.css
// module id = ./src/app/components/home/home.component.css
// module chunks = main